import {GQL_ContractType} from '../../generated/graphql'

export type ContractTypeMeta = {
  value: GQL_ContractType
  label: string
  descriptionItems: string[]
}

export const CONTRACT_TYPE_ORDER: GQL_ContractType[] = [
  GQL_ContractType.Care,
  GQL_ContractType.CarePlus,
  GQL_ContractType.FullService_1,
  GQL_ContractType.FullService_2,
  GQL_ContractType.Firewood,
  GQL_ContractType.Minigolf,
]

export const CONTRACT_TYPES: Record<GQL_ContractType, ContractTypeMeta> = {
  [GQL_ContractType.Care]: {
    value: GQL_ContractType.Care,
    label: 'Care',
    descriptionItems: [
      'Kunden köper in och byter ut produkter',
      'Piffl ansvarar för alla tekniska åtgärder',
      ' → "Kunden gör det fysiska bytet, Piffl gör det tekniska"',
    ],
  },
  [GQL_ContractType.CarePlus]: {
    value: GQL_ContractType.CarePlus,
    label: 'Care+',
    descriptionItems: [
      'Piffl skickar produkter inklusive tekniska delar',
      'Kunden byter ut produkterna (t.ex. i Norrland)',
      ' → "Piffl levererar, kunden utför bytet"',
    ],
  },
  [GQL_ContractType.FullService_1]: {
    value: GQL_ContractType.FullService_1,
    label: 'Full service 1',
    descriptionItems: ['Piffl byter ut produkter', 'Piffl ansvarar för alla tekniska åtgärder', ' → "Allt utförs av Piffl"'],
  },
  [GQL_ContractType.FullService_2]: {
    value: GQL_ContractType.FullService_2,
    label: 'Full service 2',
    descriptionItems: [
      'Piffl skickar produkter. Kunden byter ut.',
      'Tekniska åtgärder utförs av Piffl och/eller kund (ex. batteribyten)',
      ' → "Piffl levererar, tekniskt ansvar delas"',
    ],
  },
  [GQL_ContractType.Firewood]: {
    value: GQL_ContractType.Firewood,
    label: 'Firewood',
    descriptionItems: [
      'Gäller endast vedboxar',
      'Kunden fyller på ved',
      'Tekniska åtgärder utförs av Piffl och/eller kund',
      ' → "Kunden sköter ved, teknik delas"',
    ],
  },
  [GQL_ContractType.Minigolf]: {
    value: GQL_ContractType.Minigolf,
    label: 'Minigolf',
    descriptionItems: ['Gäller endast singel/minigolf-boxar', 'Kund fyller på med utrustning', 'Tekniska åtgärder utförs primärt av kund'],
  },
}

export const getContractTypeMeta = (t?: GQL_ContractType | null): ContractTypeMeta | null => {
  if (!t) return null
  return CONTRACT_TYPES[t]
}

export const contractTypeLabel = (t?: GQL_ContractType | null): string => {
  if (!t) return '-'
  return CONTRACT_TYPES[t]?.label ?? String(t)
}

export const contractTypeDescription = (t?: GQL_ContractType | null): string => {
  if (!t) return ''
  return CONTRACT_TYPES[t]?.descriptionItems?.join('\n') ?? ''
}
